import { Link } from 'react-router-dom';

interface ErrorPageProps {
  code: string;
  emoji: string;
  title: string;
  description: string;
  details?: string;
  actions?: React.ReactNode;
}

export default function ErrorPage({ code, emoji, title, description, details, actions }: ErrorPageProps) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-0)',
      padding: 24,
    }}>
      <div className="card" style={{ maxWidth: 760, width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 44 }}>{emoji}</div>
          <div>
            <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '1px', color: 'var(--accent)', fontWeight: 700 }}>
              Error {code}
            </div>
            <h1 style={{ fontSize: 28, margin: 0 }}>{title}</h1>
          </div>
        </div>

        <p style={{ color: 'var(--text-2)', lineHeight: 1.6, marginBottom: 16 }}>{description}</p>

        {details && (
          <div style={{
            background: 'var(--bg-2)',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: 12,
            marginBottom: 16,
            color: 'var(--text-2)',
            fontSize: 13,
            lineHeight: 1.5,
          }}>
            {details}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {actions ?? (
            <>
              <Link className="btn btn-primary" to="/">Go to Dashboard</Link>
              <button className="btn btn-ghost" onClick={() => window.location.reload()}>Reload</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
